module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "chap02"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("THE ESSENCE OF LIBERAL CHRISTIANITY")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("I came that they may have life, and have it abundantly.")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("—John 10:10")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Love bears all things, believes all things, hopes all things, endures all things.")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("—1 Corinthians 13:7")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("You shall love your neighbor as yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_vm._v("—"), _c('em', [_vm._v("Leviticus 19:18; Matthew 22:39")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("There is no fear in love, but perfect love casts out fear.")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("—1 John 4:18")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("T")]), _vm._v("he essence of Christianity, as shared by conservatives and liberals alike, is love. Conservatives often argue that liberal Christians don't take truth seriously enough: biblical truth, the truth about how God rules, and the truth of Jesus Christ as the divine way, truth, and life. Yet, all Christians are clear about the fundamental proclamation that God is love. Jesus is the human incarnation of that divine love. Here's where we need to begin for any understanding of the Christian life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The radical kind of love that Jesus embodied and taught—loving even one's enemies—also makes Christianity unique among the major faith traditions of the world. University of California (Berkeley) professor Huston Smith is the author of "), _c('em', [_vm._v("The World's Religions")]), _vm._v(", a best-selling book that has chapters on Hinduism, Buddhism, Islam, Judaism, and Christianity, among others. As the author examines Christianity comparatively with other religions, he finds that its unique contribution, the essence of its good news, is a new and different kind of love as preached and practiced by Jesus, and ultimately by many of his followers. Smith writes, “Conventional love is evoked by lovable qualities in the beloved, but the love [that] people encountered from Christ embraced sinners and outcasts, Samaritans and "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("enemies.” Smith points out that this kind of love dramatically reduced Christians’ fears, including their fear of death. It also released Christians from the crippling confines of ego. They were freed to find the joy of their full selves after letting go of their small, everyday selves."), _c('a', {
    attrs: {
      "id": "inote-122"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-122",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("CHRISTIANITY IS JOYFUL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I can remember as a child in Sunday school thinking that the Christian life sounded pretty burdensome. “Take up your cross.” “Give away all that you have.” “Sacrifice.” “Follow the straight and narrow way.” Basically, it didn't seem like a lot of fun. Did Christians ever laugh and play? Did they ever just hang out? Did they ever do anything I'd now call frivolous or indulgent? A biblical commentary I use articulates my childhood feelings in this rather elegant way: “The Christian mode of life must be an intolerably dull and boring affair, a repressing of what everyone wants to do, a forcing of oneself to comply with what nobody could wish or choose, a shivering with chattering teeth in the gloom of a chilly monastic twilight.”"), _c('a', {
    attrs: {
      "id": "inote-123"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-123",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But that's not it at all! It took me a while, but later in life I stumbled upon these wonderful words of Jesus: “I came that they may have life, and have it abundantly.”"), _c('a', {
    attrs: {
      "id": "inote-124"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-124",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" Now you're talking! A breath of fresh air! The abundant life, not the life of renunciation. Out of the cold gloom into the warm sunlight. Maybe laughter and playfulness and fun have a role after all. So Christianity took on a completely different cast for me. I began seeing things in terms of the joy of unconditional love that Jesus represented. I started experiencing holy days as holidays or occasions for celebration, not just obligation. It became a kick to sing in church and to listen to the magnificence of the organ. I came to delight in the sense of friendship and community I could have in church.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Christmas was the holiday that epitomized celebration and warm human relations for me. In college I heard anew the biblical story of an angel announcing to shepherds out in the field: “I am bringing you good news of great joy for all the people.”"), _c('a', {
    attrs: {
      "id": "inote-125"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-125",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" As I came to understand, that means for all of "), _c('em', [_vm._v("us:")]), _vm._v(" for those of us rushing about desperately trying to get ready for the winter holidays, for those overwhelmed by the commercialism of the season, for those who can't find enough time for families and friends, for those who experience this as one of the most stressful times of the year, for "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("those who have lost jobs in a sour economy, for those who despair of peace and justice ever coming in a world filled with terrorism and oppression.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I used to struggle with exactly what the “good news of great joy” was that the angel speaks about in the gospel story. Luke explained that it was news of the birth of the Savior, the Messiah, the Lord."), _c('a', {
    attrs: {
      "id": "inote-126"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-126",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" This earth-shattering announcement came first to common people, and the announced Messiah was not the crown prince whom most modern commentators say"), _c('a', {
    attrs: {
      "id": "inote-127"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-127",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" was described by the Jewish prophet Isaiah more than seven hundred years before Jesus. Worldly authority was to rest upon that prince's shoulders, and he was to be named Wonderful Counselor, Mighty God, Everlasting Father, Prince of Peace."), _c('a', {
    attrs: {
      "id": "inote-128"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-128",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" Instead, Luke tells us, the Messiah was born to an unmarried couple staying with animals in a barn."), _c('a', {
    attrs: {
      "id": "inote-129"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-129",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" Instead of being dressed in royal garments and laid in an ornate crib, the long-expected Messiah was wrapped in mere bands of cloth and placed in a feeding trough."), _c('a', {
    attrs: {
      "id": "inote-130"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-130",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" A third of a century later, after less than three years of active ministry, this Messiah was ignominiously and painfully executed on a cross at the hands of the colonial rulers of Israel. He died being taunted by soldiers who had put a crown of thorns on his head and a plaque on the top of his cross titling him “The King of the Jews.”"), _c('a', {
    attrs: {
      "id": "inote-131"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-131",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, again, what's the “good news of great joy” for Christians? Here's what I came to understand. First of all, it's the momentous news that, through Jesus, God is seen to have entered into the daily life of this workaday world and redeemed it. Everything is thrown into a new light with God represented in this particular human form. Exactly how God has redeemed or saved the world through Jesus, I learned, has been debated by theologians for millennia. For me, though, it primarily came to mean that, through a new kind of divine love, all of our evil deeds are ultimately forgivable, and we're given a vision of loving-kindness as our ultimate meaning and purpose in life. Progressively I came to appreciate some of the practices that Christians have historically used to exercise love and to demonstrate our gratitude for God's gift to the world: simplicity, loving-kindness, and prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a young adult, I learned an old American Shaker hymn, “ ’Tis a Gift to Be Simple,” that praises simplicity as the source of the fullest freedom and delight. In the end, the hymn tells us, through simplicity we discover love; through simplicity we find ourselves in just the right place and we come out right in the end. Compare normal life in modern America. It's "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("complex. It's sophisticated. It's technologically advanced. It's busy. Yet, it's still possible and critical to pursue a life of simplicity here, amidst complexity or on the far side of complexity. It turns out too that simplicity is valued in modern science and technology. Mathematicians search for the “more elegant solution,” and engineers strive for simplicity of design.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In high school I read the work of the English poet William Wordsworth, who laments: “The world is too much with us; late and soon. Getting and spending we lay waste our powers. Little we see in Nature that is ours. We have given our hearts away, a sordid boon.”"), _c('a', {
    attrs: {
      "id": "inote-132"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-132",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" I came to recognize how we desperately need to stop regularly to smell the flowers, to remember that other people are ends in themselves and not means to our ends. We need to keep our eyes on what really matters in our lives—and what matters inevitably lies in relationships, not in material possessions. Good news of great joy appears to simple shepherds and loving parents as they gaze at a baby in a cold barn, not as they enjoy worldly riches in a sumptuous castle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The King James translation of the angels’ appearance to the shepherds ends with the words, “Glory to God in the highest, and on earth peace, good will toward men.”"), _c('a', {
    attrs: {
      "id": "inote-133"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-133",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("12")])]), _vm._v(" Jesus comes into the world with a message of peace and goodwill. How can we regularly exercise gratitude and goodwill, I wondered. The Reverend John Haynes Holmes, a minister who helped found both the NAACP and the American Civil Liberties Union,"), _c('a', {
    attrs: {
      "id": "inote-134"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-134",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" described Christmas “as though a spell were cast upon us, to save us … from our cruelties … and make us ministers of love … This is our task—to seize and hold and perpetuate the Christmastide. To live a life, and not merely a single day or season, which is delivered of prejudice and pride, hostility and hate, and committed to understanding, compassion and goodwill!”"), _c('a', {
    attrs: {
      "id": "inote-135"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-135",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" The way to exercise gratitude and good will is through regular acts of loving-kindness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reading more about Jesus in the gospel of Matthew, I learned that this sort of kindness is worked out in a practice that includes doing good to those who hate you, turning the other cheek, forgiving others their trespasses, feeding the hungry, and sheltering the homeless. These may seem like radical demands, but Jesus sums them up this way: “In everything do to others as you would have them do to you; for this is the law and the prophets.”"), _c('a', {
    attrs: {
      "id": "inote-136"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-136",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("15")])]), _vm._v(" So, our practice should have not only elements of social service but also commitment to social change for the poor, the oppressed, and the war-torn throughout the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("Finally, along with simplicity and loving-kindness, I came to appreciate the practice of prayer. A Christmas service is filled with prayer, both spoken and sung. Many churches begin at the crèche with a prayer that we may enjoy forever the love of Christ, and worshipers sing “Joy to the World” that earth may receive her King. There are usually prayers of the people, prayers at the Eucharist or Communion, and a prayer of benediction. Would that we could live as if our whole lives were a prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My way of praying changed as I grew older. It became less a matter of addressing God in praise or petition and incorporated varied forms of contemplation. Christian prayer has traditionally also had a listening dimension, which is called meditation. That can be done not only sitting but also walking and acting with an open, attentive attitude. A third form has been contemplative prayer, centered on the divine presence within us—perfected by mystics who report experiences of unity with God. A fourth way has been prayer in communion with other people, most obviously in a worship service but also in many smaller contexts in which we join with others for support and companionship to evoke the presence of God."), _c('a', {
    attrs: {
      "id": "inote-137"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-137",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" I learned how prayer, through a variety of forms, can help free us from our own ego, help us see the big picture rather than the petty and the transitory, and help us put everyday stress into context.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, my prayer for each of us became that through the practice of simplicity we might slow down enough to see into the true heart of things, that through loving-kindness we might open ourselves to true relationships in a transformed world, and that through prayer we might transcend ourselves in true commitment to the life force itself, which for Christians goes by the name of Jesus the Savior, the Messiah. Then we can truly hear the good news of wondrous joy for all people that's announced on the wondrous Christian holiday of Christmas.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("THE ROMANCE OF CHRISTIANITY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now, what about romance and Christian love? As a teenager, I found that romantic feelings were my most powerful experience of love. Daydreaming in school, reading novels, going to movies, and talking to friends—it was this form of love that really hit home. Valentine's Day came to symbolize love far more potently than Christmas. Eventually I learned that Saint "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("Valentine's Day actually began in commemoration of a third-century Christian priest who was martyred in Rome. By the Middle Ages, Saint Valentine had become associated with the union of lovers under conditions of stress. By the twentieth century his holiday was being celebrated with the widespread exchange of romantic little messages called valentines."), _c('a', {
    attrs: {
      "id": "inote-138"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-138",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a minister, I began to see the evolution of Saint Valentine's Day this way: It begins as a commemoration of "), _c('em', [_vm._v("spiritual")]), _vm._v(" love, later becomes a celebration of "), _c('em', [_vm._v("committed interpersonal")]), _vm._v(" love, and is now primarily a rather commercialized carnival of "), _c('em', [_vm._v("romantic")]), _vm._v(" love. I should make it clear that as a minister I have nothing against romantic love. When I officiate at weddings, I often describe romantic love as a great gift. But I then go on to explain that it's not a sufficient foundation for a strong, devoted partnership. I'm convinced there needs to be a thoroughgoing connection between romantic love, committed partnership, and spiritual love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In terms of romantic love, the Song of Solomon in the Old Testament does a pretty good job of describing the feelings of two people who have fallen, hopelessly, head-over-heels, in love with each other: “You have ravished my heart, my sister, my bride; you have ravished my heart with a glance of your eyes, with one jewel of your necklace. How sweet is your love … how much better is your love than wine, and the fragrance of your oils than any spice! Your lips distill nectar, my bride; honey and milk are under your tongue.” The recipient of these sentiments then exclaims: “My beloved is all radiant and ruddy, distinguished among ten thousand. His head is the finest gold; his locks are wavy, black as a raven…His lips are lilies, distilling liquid myrrh. His arms are rounded gold, set with jewels. His body is ivory work, encrusted with sapphires. His legs are alabaster columns, set upon bases of gold … He is altogether desirable.” The narrator then adds: “Many waters cannot quench love, neither can floods drown it.”"), _c('a', {
    attrs: {
      "id": "inote-139"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-139",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Note the qualities of this romantic love. Very physical. All about arms and legs, lips and tongues, hair and eyes. All about bodies, and all about overwhelming desire. It's powerful; it's wonderful; there's nothing like it. I'll never forget "), _c('em', [_vm._v("my")]), _vm._v(" first romantic experiences, filling up every thinking and feeling moment of the day and night, as incredibly exciting, as blissful.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet, there are some major downsides to romantic love. There's the pain of not being able to be with a lover in an all-fulfilling way all of the time. That pain reaches its extreme expression in Shakespeare's "), _c('em', [_vm._v("Romeo and Juliet,")]), _vm._v(" in which the lovers take their lives when each thinks the other is dead. "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("Romantic love also tends to objectify the other—physically focusing on bodies and on the desire for sexual gratification. It also exists largely in fantasy land, either never being consummated or slipping away as real familiarity with the other person grows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many social scientists have described romantic love as essentially narcissism. What one loves is not the other, but one's "), _c('em', [_vm._v("own image")]), _vm._v(" of the other. One loves one's "), _c('em', [_vm._v("own projection")]), _vm._v(" of what an ideal lover should be, which ultimately bears little resemblance to the actual person to whom affections are directed. In Jungian psychological terms, one loves the image of one's "), _c('em', [_vm._v("own")]), _vm._v(" anima or animus that is projected onto the other person. Romantic lovers also tend to love the state of “being in love” as much or more than the actual object of love. One becomes lost in one's own daydreams, sexual fantasies, romantic feelings, and aspects of the chase, like making oneself as attractive as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More mature, committed interpersonal love is described well by author and Stanford alumna bell hooks in her books "), _c('em', [_vm._v("All About Love: New Visions")]), _c('a', {
    attrs: {
      "id": "inote-140"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-140",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" and "), _c('em', [_vm._v("Salvation.")]), _c('a', {
    attrs: {
      "id": "inote-141"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-141",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" She cites mutuality as the heart of love: “The essence of true love is mutual recognition—two individuals seeing each other as they really are. We all know that the usual approach is to meet someone we like and put our best self forward, or even at times a false self, one we believe will be more appealing to the person we want to attract. When our real self appears in its entirety, when the good behavior becomes too much to maintain or the masks are taken away, disappointment comes.”"), _c('a', {
    attrs: {
      "id": "inote-142"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-142",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In true love, mutual love, “individuals usually feel in touch with each other's core identity. Embarking on such a relationship is frightening precisely because we feel there is no place to hide. We are known.”"), _c('a', {
    attrs: {
      "id": "inote-143"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-143",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" There is also a dynamic dimension to this kind of love, as each person gets to know herself or himself better, as well as coming to know the other more deeply. Honesty and openness are critical, as is the commitment to put mutuality of relationship ahead of power—ahead of any attempt to control the other."), _c('a', {
    attrs: {
      "id": "inote-144"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-144",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mutual love is not something that we fall into, or that falls into our laps. After the giddiness and sliding on the slippery slope of romantic love, mutual love requires practice, discipline, devotion, and commitment. The compassionate, empathetic listening to the other that's required takes energy, especially when it triggers one's own feelings of powerlessness, helplessness, and vulnerability. Therefore, hooks counsels, make time for "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("those conversations when we're not bone weary, irritable, or preoccupied, and practice making that time available."), _c('a', {
    attrs: {
      "id": "inote-145"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-145",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The rewards are great: the courage to face reality, to embrace our true self and that of our partner, and then to grow and change together through our mutual emotional vulnerability. As hooks puts it, “We can only move from perfect passion to perfect love when the illusions pass and we are able to use the energy and intensity generated by intense, overwhelming, erotic bonding to heighten self-discovery.” When that self-discovery is linked with openness and empathetic listening to the other, partners grow and change together. In the best sense, in loving fully and deeply, we risk changing ourselves."), _c('a', {
    attrs: {
      "id": "inote-146"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-146",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" As Catholic monk Thomas Merton asserted: “Love affects more than our thinking and our behavior toward those we love. It transforms our entire life. Genuine love is a personal revolution. Love takes your ideas, your desires, and your actions and welds them together in one experience and one living reality which is a new you.”"), _c('a', {
    attrs: {
      "id": "inote-147"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-147",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This gets us close to the third dimension of love—spiritual love. In my career of more than thirty years in the ministry, there have been many, many times when couples have asked me to read from the thirteenth chapter of the apostle Paul's First Letter to the Corinthians as they are united for life: “Love is patient; love is kind; love is not envious or boastful or arrogant or rude. It does not insist on its own way; it is not irritable or resentful; it does not rejoice in wrongdoing.” This kind of spiritual love at its core is giving and forgiving. Giving generously to one's partner means recognizing and responding when the other person needs our attention. It means freely sharing time, skills, and resources, to find that by giving in this way we receive many times over. Perhaps the greatest gift we can give, though, at the spiritual level is forgiveness: “Love is kind…it is not irritable or resentful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Almost fifty years ago a Harvard classics professor named Erich Segal wrote a sentimental little novel called "), _c('em', [_vm._v("Love Story.")]), _vm._v(" It became a best seller and was turned into a high-grossing Paramount film starring Ali McGraw and Ryan O'Neal. It begins with the line, “What can you say about a 25-yearold girl who died?” Perhaps its most famous line, however, is “Love means never having to say you're sorry.” I've always felt Erich Segal got it halfright but then profoundly wrong. I'd say instead: “Spiritual love means always being able to forgive the other when he or she genuinely says, ‘I'm sorry.’ ” In the movie, preppy Oliver Barrett IV marries a woman from the "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("other side of the tracks, Jennifer Cavalari, soon after they graduate from Harvard and Radcliffe respectively. Oliver's successful, wealthy, and distant father doesn't approve of the marriage, and he cuts Oliver off financially as he is beginning to attend Harvard Law School. Jennifer works hard to put Oliver through law school. Near the end of the three years, his father tries to initiate a reconciliation by sending his son and daughter-in-law an invitation to his sixtieth birthday. Oliver refuses to go and makes Jenny do the dirty work of calling his father to say no. He becomes enraged at Jenny when she adds this comment to Oliver's father over the phone: “You know, in his own way your son loves you very much.” When Oliver later apologizes to Jenny for his hard-heartedness, she speaks that famous line, “Love means never having to say you're sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the end of the movie, though, it becomes clear that Oliver hasn't gotten the spiritual point of Jennifer's capacity to forgive. Jenny dies of cancer and Oliver's father drives to the hospital, finds Oliver, and again tries to effect a reconciliation by telling Oliver how sorry he is. Oliver uses the famous line like a bludgeon, walks away from his father, and the movie ends. In Oliver's hands, the line becomes a condemnation of his father for supposedly never having loved him, otherwise, why would his father have to say he was sorry? And Oliver's "), _c('em', [_vm._v("resentment")]), _vm._v(" triumphs over the "), _c('em', [_vm._v("spiritual")]), _vm._v(" capacity for loving forgiveness that he should have learned from his wife, Jenny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ultimately we're all imperfect beings. The Christian message is one of "), _c('em', [_vm._v("divine")]), _vm._v(" forgiveness and reconciliation to God through the kind of love Jesus modeled. Spiritual love between partners, from the perspective of the Christian tradition, is one that has repentance and forgiveness at its core. Beyond that lies the willingness to give totally of oneself to the other, even unto death. The highest level of spiritual love may then be saintly love, exemplified in Saint Valentine's martyrdom for his unstinting love of Christ. My valentine love message, though, is pitched a bit lower than saintly love: Give a valentine joyfully to one you love, but don't stop at romantic love. If you have a partner, try to practice mutual love, which involves a discipline of openness and honesty, empathetic listening, personal vulnerability, and willingness to change. Work on developing spiritual love—love which is freely giving and forgiving. Then perhaps Saint Valentine's Day can again be what it once was meant to be.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("WHAT'S SPECIAL ABOUT CHRISTIAN LOVE?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Christians seem to claim they have a corner on what others would call a human universal—love. A so-called new commandment is given by Jesus to his disciples at the Last Supper, according to the gospel of John: “You should love one another.”"), _c('a', {
    attrs: {
      "id": "inote-148"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-148",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" Yet, in the third book of the Old Testament, Leviticus, which dates back in written form to the sixth century before Christ,"), _c('a', {
    attrs: {
      "id": "inote-149"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-149",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" it's stated “You shall love your neighbor as yourself.”"), _c('a', {
    attrs: {
      "id": "inote-150"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-150",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" Jesus himself cites Leviticus, along with a verse from another Old Testament book, Deuteronomy, when asked by his religious enemies which commandment is the greatest. He responds, “You shall love the Lord your God with all your heart, and with all your soul, and with all your mind. This is the greatest and first commandment. And a second is like it: You shall love your neighbor as yourself. On these two commandments hang all the law and the prophets.”"), _c('a', {
    attrs: {
      "id": "inote-151"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-151",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition, much of Jesus's ministry of love seems derived from specific injunctions in Leviticus that lead up to the commandment to love one's neighbor as oneself. For example, the poor and the alien are to be provided for; the deaf and blind are to be protected; judgments are to be just, without deferring to the great; slander is proscribed along with theft and fraud; no one is to hate another in his or her heart, take vengeance, or even bear a grudge."), _c('a', {
    attrs: {
      "id": "inote-152"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-152",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps what's new about Jesus's commandment to his disciples to love one another is the context in which it's given. He's to be betrayed by one of his disciples very soon. Most of the rest of them will run away as soldiers take Jesus to be tried, flogged, and crucified. And the apostle Peter—upon whom Jesus says he will build his church"), _c('a', {
    attrs: {
      "id": "inote-153"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-153",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v("—will deny him three times. It seems like a sorry and spineless group of so-called friends whom Jesus calls upon to love him and to love each other. Yet, the important point, I think, is that Jesus is calling upon them for a new kind of love beyond that requested in Leviticus. He's calling for a kind of love for which one is willing to die, and at first his disciples don't seem to be up to it. Most of us can probably identify with their sentiments!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the gospel of John, Jesus puts the point more explicitly: “This is my commandment, that you love one another as I have loved you. No one has greater love than this, to lay down one's life for one's friends.”"), _c('a', {
    attrs: {
      "id": "inote-154"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-154",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" Jesus has so loved his friends, and so radically acted out his love in the world, "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("that he's about to be crucified as a threat to the Roman empire, not to mention to the religious establishment of his day. This is the man who, just days before his Last Supper, rode into Jerusalem to the enchantment of crowds waving palms and shouting “Hosanna! Blessed is the one who comes in the name of the Lord—the King of Israel.”"), _c('a', {
    attrs: {
      "id": "inote-155"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-155",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" Jesus overturned the moneychangers’ tables in the temple, saying that they had made the most sacred place in Israel a den of robbers."), _c('a', {
    attrs: {
      "id": "inote-156"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-156",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" He cured the blind and the lame."), _c('a', {
    attrs: {
      "id": "inote-157"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-157",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" He preached against the scribes and Pharisees, calling them hypocrites, claiming they lock people out of the kingdom of heaven, and on earth neglect the weightier matters of the law: justice, mercy, and good faith."), _c('a', {
    attrs: {
      "id": "inote-158"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-158",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" He said that the mighty will be brought low, while the lowly hungry should be fed, the thirsty given drink, the stranger welcomed, the naked clothed, the sick cared for, and the prisoners visited."), _c('a', {
    attrs: {
      "id": "inote-159"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-159",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" Brave and powerful words and actions then. Brave and powerful in today's war-torn world as well, as when we think, for example, of how the mighty treated those incarcerated in the prisons of Iraq before and after the fall of Saddam Hussein. Jesus saw all that he said and did as an expression of true love. That's what he expected of his disciples, even though it put them at risk of their lives. And that's what he expects of us as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps one of the best modern exemplars of this commandment of a new type of love was Martin Luther King Jr. He lived and died trying to manifest the radical form of love to which Jesus has called us. Remember how he put it in the sermon he delivered the very night before he was assassinated: “Now we're going to march again … For when people get caught up with that which is right, and they are willing to sacrifice for it, there is no stopping point short of victory … We need all of you … Let us develop a kind of dangerous unselfishness…The question is not, ‘If I stop to help this man in need, what will happen to me?’ [The question is] ‘If I do not stop to help the sanitation workers, what will happen to the m? ’ … [ W hen] I got i nto Me mph is … some b egan to … talk about the threats that were out. What would happen to me from some of our white brothers? … Like anybody, I would like to live a long life. Longevity has its place. But I'm not concerned about that now. I just want to do God's will … I'm not fearing any man. Mine eyes have seen the glory of the coming of the Lord.”"), _c('a', {
    attrs: {
      "id": "inote-160"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-160",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("King said more than once that we're not fully alive until we've found something for which we're willing to die. In his book "), _c('em', [_vm._v("The Strength to Love,")]), _vm._v(" he explains that “The kind of love which led Christ to a cross and kept Paul "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("unembittered amid the angry torrents of persecution is not soft, anemic, and sentimental. Such love confronts evil without flinching … ” Looking at the arms race of his day, though, designed to ease fear through strength, he wrote that “Not arms, but [only] love, understanding and organized goodwill can cast out fear.”"), _c('a', {
    attrs: {
      "id": "inote-161"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-161",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, the reality is that most of us are not Martin Luther Kings. How can we, realistically, in our own daily lives, understand and practice the love that Jesus spoke of? To start with, for each of us there's our mother's love. Most mothers I know say that they love their children so deeply and fully that in an instant they would unquestioningly give up their own lives to save one of their children's lives. Many fathers might say that too. So, there's a multitude of parents whose love is so strong that they are willing to die for another. They meet King's test of being fully alive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I've conducted weddings for which the bride and groom asked me to read the aforementioned passage from John's gospel. I’ ve found myself saying to these couples that “Your joy as husband and wife will be complete only when you can call each other true friends and when you are ready to lay down your lives for each other.” I really believe that's true. Being fully alive, fully committed, and fully fulfilled in a marriage entails the willingness to give up one's life instantaneously and unquestioningly to save your spouse's life. Children and spouses are a group of people for whom many of us ordinary folk would be willing to give up our lives. So, it would seem as if we have exceeded the threshold for Jesus's commandment of love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But what about friends who are not family members? When I was a child, I was told the story of Damon and Pythias, two friends in the Sicilian city-state of Syracuse in the fourth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C")]), _vm._v(". Pythias spoke out against the king, who ordered him executed for treason. Pythias asked permission to go home long enough to say goodbye to his wife and children and put his household in order. His friend Damon instantly volunteered to be imprisoned until Pythias returned and to be killed himself if Pythias didn't show up on the execution date. As the fatal day approached without Pythias returning, the king came to the prison to sneer at Damon and to see if he was sorry for having made such an arrangement. “You were a fool to rely on your friend's promise,” scoffed the king. “Did you really think he would sacrifice his life for you or anyone else?” Damon simply replied, “He is my friend. I trust him.” As Damon was being led out to be executed "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("on the crucial day, Pythias suddenly appeared, breathlessly exclaiming, “You are safe, praise the gods. My ship was wrecked in a storm, and then bandits attacked me on the road. But I refused to give up hope, and at last I've made it back in time. I am ready to receive my sentence of death.” The king was so astonished and moved that he revoked the death sentence out of respect for their friendship."), _c('a', {
    attrs: {
      "id": "inote-162"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-162",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If we have friendships of this level of devotion, our group of people to fulfill Jesus's commandment of love may now include children, spouses, and close friends. Our challenge, then, is to keep expanding the circle to take in increasing numbers of people. Jesus's commandment becomes both aspirational and inspirational. Will we be ready to follow a new Martin Luther King who calls us to love even our enemies unto death? Will we be ready to put our lives nonviolently on the line, without fear, to promote peace and justice for all?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I assume many of us recognize how wide and deep mother love can be. I hope many of us have or will have some life experience with a partner to whom we're committed unto death. I hope each of our lives has or will include at least one friendship at the level of Damon's and Pythias's. The next step for Christians is to follow fully in Jesus's footsteps, building an expanding circle of self-sacrificing love that includes the hungry and the thirsty, the alien, the homeless, the sick, and the imprisoned. And ultimately, the Christian message is that it's only by being willing to lose our lives in service to others that we will ever truly find our lives."), _c('a', {
    attrs: {
      "id": "inote-163"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-163",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("42")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("LOVE CONQUERS ALL, EVEN FEAR")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Christian love has another important dimension that needs to be described explicitly: Love conquers fear. Soon after the terrorist attacks of September 11, 2001, I preached a sermon in the Stanford Memorial Church entitled “Nothing to Fear but Fear Itself.” Osama bin Laden had spoken these words: “There is America, full of fear from its north to its south, from its west to its east. Thank God for that.”"), _c('a', {
    attrs: {
      "id": "inote-164"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-164",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" In response, I quoted Franklin D. Roosevelt's famous words from his first inaugural address in 1933 in the midst of the Great Depression: “The only thing we have to fear is fear itself.”"), _c('a', {
    attrs: {
      "id": "inote-165"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-165",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("44")])]), _vm._v(" Those are words that many also needed to remember as the worldwide financial crisis struck in late 2008. Yet, years after September "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("11, 2001, fear about terrorism is still very much in the air. Thousands of American men and woman have died on the soils of Iraq and Afghanistan, and many more civilians have been killed in those countries. Threats of violence against innocents still loom large, abroad and at home. Much of the world long ago moved from a sympathetic solidarity with Americans—“We are all Americans”—to a deep hatred for America. We have gone through profoundly divisive election seasons. Instead of being united as Americans, we have been torn asunder into blue states and red states, liberals and conservatives—although president Barack Obama gives us hope that we can now find new bipartisan consensus as one United States of America. I have known many liberal Christians during the period since 9/11 who have been genuinely fearful to speak out, to organize, to act politically or even religiously. They have felt a new McCarthyism in the air, an atmosphere in which they can be labeled a terrorist sympathizer, a socialist, a communist—all labels that were bandied about in the 2008 election season. On the other hand, I know conservative Christians who are genuinely fearful of where our culture is headed in terms of what they consider its abandonment of fundamental values and national security.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin Luther King wrote at some length about fear in his 1963 book "), _c('em', [_vm._v("The Strength to Love.")]), _vm._v(" He wondered: “In these days of catastrophic change and calamitous uncertainty, is there anyone who does not experience the depression and bewilderment of crippling fear, which, like a nagging hound of hell, pursues our every footstep?”"), _c('a', {
    attrs: {
      "id": "inote-166"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-166",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" He invoked courage, one of the four classic virtues, as a critical antidote against fear. Quoting Saint Thomas Aquinas, King described courage as “the strength of mind capable of conquering whatever threatens attainment of the highest good.”"), _c('a', {
    attrs: {
      "id": "inote-167"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-167",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("King also writes about many historical figures’ ideas about fear and courage. He reminds us that Roosevelt's quote was derived from Henry David Thoreau, who wrote in his "), _c('em', [_vm._v("Journal")]), _vm._v(" in 1851 that “Nothing is so much to be feared as fear.” A century before Christ, the Stoic philosopher Epictetus, once himself a slave, exclaimed, “It is not death or hardship that is a fearful thing, but the fear of hardship and death.” King's own theology was deeply influenced by the contemporary liberal Christian theologian Paul Tillich, who explained that “Courage is self-affirmation ‘in spite of’ that which tends to hinder the self from affirming itself.” King agrees. He makes sure that this isn't confused with selfishness, "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("though, “for self-affirmation includes both a proper self-love and a properly positioned love of others.” Citing psychoanalyst Erich Fromm, King reminds us that self-love and love of others, properly understood, are interdependent."), _c('a', {
    attrs: {
      "id": "inote-168"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-168",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("King's understanding of courage was by no means facile, either. He insisted that courage is not the absence of fear, it is the ability to act in spite of it. As he put it, “Many of our fears are not mere snakes under the carpet. Trouble is a reality in this strange medley of life, dangers lurk within the circumference of every action…and death is a stark, grim, and inevitable fact of human experience.”"), _c('a', {
    attrs: {
      "id": "inote-169"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-169",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" With hindsight, we see that King's own fears were often realized: His home was bombed, he was stabbed with a knife, just shy of his aorta, and ultimately he was assassinated by a racist's bullet. Meanwhile, he constantly put himself in harm's way and reaped the consequences of his nonviolent direct action as he defied unjust laws, marched through mean streets, and was carried off to inhospitable jails.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("King does not counsel trying to eliminate fear from our lives. Indeed, he even calls fear “a powerfully creative force” when it is linked with the virtue of courage. Fear is part of the animal fight-or-flight instinct, and without it human beings could not have survived in either the primitive or modern worlds. “Every great invention and intellectual advance represents a desire to escape from some dreaded circumstance or condition … If people were to lose their capacity to fear, they would be deprived of their capacity to grow, invent, and create. So, in a sense, fear is normal, necessary, and creative.”"), _c('a', {
    attrs: {
      "id": "inote-170"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-170",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet, King is well aware that fear can poison and distort our inner lives as surely as it can motivate us to improve our individual and collective welfare. Therefore, the problem is not how to be rid of fear, but how to harness it. The main way to do this is through love. The particular kind of love he's talking about is one that leads to disciplined nonviolent action, in the face of all blows and beatings, even unto death. The kind of love that becomes organized goodwill. The kind of love that seeks justice for both blacks and whites, for both the oppressed and the oppressors. Internationally, King claimed that war is not at root a consequence of hate. “Close scrutiny reveals this sequence: first fear, then hate, then war, and finally deeper hatred.” In terms of personal anxieties, fear generates a feeling of insecurity, lack of self-confidence, and concern about failure, "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("which can then harden into hatred. Hatred then paralyzes life; only love can release it. Hatred darkens life; only love can illuminate it."), _c('a', {
    attrs: {
      "id": "inote-171"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-171",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Where does this kind of courage-engendering love come from? King believed that deep, effective love is linked with faith in God. God for King is a “benign Intelligence whose infinite love embraces all of humankind.” When fears inevitably come, faith “assures us that the universe is trustworthy and that God is concerned … Irreligion, on the other hand, would have us believe that we are orphans cast into the terrifying immensities of space in a universe that is without purpose or intelligence.”"), _c('a', {
    attrs: {
      "id": "inote-172"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-172",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("51")])]), _vm._v(" It's understandable why the latter view would drain courage and exhaust our energies. By contrast, “Religion endows us with the conviction that we are not alone in this vast, uncertain universe … This universe is not a tragic expression of meaningless chaos, but a marvelous display of orderly cosmos … Beneath and above the … uncertainties that darken our days and the vicissitudes that cloud our nights is a wise and loving God.”"), _c('a', {
    attrs: {
      "id": "inote-173"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-173",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This may all be a bit abstract and hard to fathom, leading our scientific minds to begin debating and questioning chaos versus order. Don't go there right now; there will be time for that in the next chapter. For now the point is that Christians have an actual manifestation of divine love in the person of Jesus, and Jesus concretizes it all in the human sphere. Jesus models a life of turning the other cheek and loving his enemies. Jesus is the one who talks about love in relation to the hated Samaritans, outsiders and foreigners, one of whom stops and cares for the beaten man on the dangerous road to Jericho when the Jewish exemplars of priest and Levite have passed by on the other side. Jesus, both in his own life and in his teachings, demonstrates the capacity, as King puts it, “to project the ‘I’ into the ‘thou,’ and to be concerned about one's brother.”"), _c('a', {
    attrs: {
      "id": "inote-174"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-174",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Near his death, Jesus affirms that for all human beings his kind of love is the ultimate law of the universe. He tells his disciples: “In the world you face persecution. But take courage; I have conquered the world!”"), _c('a', {
    attrs: {
      "id": "inote-175"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-175",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("54")])]), _vm._v(" Christian hope, grounded in Jesus's life, death, and resurrection, is that one's present and future belong to God, and that, as a result, all things are possible."), _c('a', {
    attrs: {
      "id": "inote-176"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-176",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("55")])]), _vm._v(" Take courage, for fear is never the last word. Ultimately, “There is no fear in love, but perfect love casts out fear.”"), _c('a', {
    attrs: {
      "id": "inote-177"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-177",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A Southern white preacher and his wife, who both supported Martin Luther King and the civil rights movement in the 1950s, wrote openly in a published memoir that the fear they experienced because of angry racists "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("was overwhelming until they turned to Psalm 27, which begins “The Lord is my light and my salvation; whom shall I fear? The Lord is the strength of my life; of whom shall I be afraid?” As they put it, “Our enemies were everywhere. They hated us and did not slacken their determination to harm us. But God's circle of love, made up of our white and Negro friends who stood by us [even as our house was bombed], never allowed us to feel alone. Our entire outlook changed. We became bolder than ever.”"), _c('a', {
    attrs: {
      "id": "inote-178"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-178",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, for those of us who fear terrorism, who fear how we Americans are seen in the world, who fear our divided country, who fear being silenced or having our fundamental values betrayed, let us learn the lesson of the church-based civil rights movement. Let's roll up our sleeves and go to work in God's circle of love, under the example of Jesus and in the activist tradition of Rev. King. Maybe we too can then say that we've been to the mountaintop. That we just want to do God's will. That we're happy and not worried about anything. That we're not fearing anybody. That we can truly sing, for our eyes have seen the glory of the coming of the Lord."), _c('a', {
    attrs: {
      "id": "inote-179"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-179",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("58")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3215582c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780230240582_10_chap02.vue
// module id = 84
// module chunks = 0